import React from "react";
import { Link } from "react-router";
import PropTypes from "prop-types";
import PaginationPrevious from "./pagination-previous";
import PaginationNext from "./pagination-next";
import util from "../util/util";

const iPhone6Width = 375;
const iPadPortraitWidth = 768;

export default function Pagination(props) {
  // the number of pages to show is based on the screen width;
  // smallest set (narrower than an iPhone 6) is 5, the wider it gets, the more we show;
  let pagesToShow = 5;

  if (window.innerWidth >= iPhone6Width) {
    pagesToShow = 7;
  }

  if (window.innerWidth >= iPadPortraitWidth) {
    pagesToShow = 11;
  }

  // create an array of all pages;
  // this will be trimmed before display;
  const pageArray = [];

  for (let i = 1; i <= props.pageCount; i = i + 1) {
    pageArray.push(i);
  }

  // determine the first and last page based off the current page;
  let firstPage =
    props.currentPage > Math.floor(pagesToShow / 2)
      ? props.currentPage - Math.floor(pagesToShow / 2) - 1
      : 0;
  let lastPage =
    props.currentPage > Math.floor(pagesToShow / 2)
      ? firstPage + pagesToShow
      : pagesToShow;

  // if the last page is past the end, adjust the first/last to be within range of pageArray;
  if (lastPage > props.pageCount) {
    firstPage = props.pageCount - pagesToShow;
    lastPage = props.pageCount;

    // can't have a negative number for the first page;
    // really screws with the processing of the array of pages;
    firstPage = firstPage < 0 ? 0 : firstPage;
  }

  const minimumPagesToShow = 2;

  // not enough pages for links, don't do anything;
  if (pageArray.length < minimumPagesToShow) {
    return null;

    // otherwise display some pagination links;
  } else {
    return (
      <nav className="pagination-nav" aria-label="Page navigation">
        <ul className="pagination">
          <PaginationPrevious
            currentPage={props.currentPage}
            path={props.path}
            queryString={props.queryString}
          />

          {pageArray.slice(firstPage, lastPage).map(page => (
            <li
              className={page === Number(props.currentPage) ? `active` : ``}
              key={page}
            >
              <Link
                to={util.returnPaginationUrl(
                  props.path,
                  page,
                  props.queryString
                )}
              >
                {page}
              </Link>
            </li>
          ))}

          <PaginationNext
            currentPage={props.currentPage}
            pageCount={props.pageCount}
            path={props.path}
            queryString={props.queryString}
          />
        </ul>
      </nav>
    );
  }
}

Pagination.propTypes = {
  currentPage: PropTypes.number, // page user is on;
  pageCount: PropTypes.number, // number of pages in the list;
  path: PropTypes.string, // url fragment;
  queryString: PropTypes.string // url params to persist on the next view;
};
